import { useAtom, useAtomValue } from 'jotai';
import { loadable } from 'jotai/utils';
import { gridDataAtom, selectedRowsAtom, entityCountsCacheAtom } from '~/atoms/gridData';
export const gridDataLoadingAtom = loadable(gridDataAtom);
export const useGridData = () => {
    const [loading] = useAtom(gridDataLoadingAtom);
    const [selectedRows, setSelectedRows] = useAtom(selectedRowsAtom);
    const entityCounts = useAtomValue(entityCountsCacheAtom);
    const error = loading.state === 'hasError'
        ? loading.error instanceof Error
            ? loading.error
            : new Error('Unknown error')
        : null;
    const gridData = loading.state === 'hasData' ? loading.data : undefined;
    return {
        gridData,
        entityCounts,
        gridDataLoadingState: loading.state,
        error,
        selectedRows,
        setSelectedRows
    };
};
